import { type ReactElement, type ReactNode, useState, useEffect } from "react"
import Modal from "src/components/Modal";
import Button from "src/components/Button";

export interface LogoutModalProps {
        title: string,
        isOpen: boolean,
        onClose: () => void,
        children?: ReactNode
}

export default function LogoutModal(props: LogoutModalProps): ReactElement {

        const onSubmit = async () => {
                props.onClose();
        }


        useEffect(() => {
        }, [])

        return <>
                <Modal isOpen={props.isOpen} modalSize="sm" onClose={props.onClose}>
                        <h2 className="text-lg font-bold text-center">
                                {props.title}
                        </h2>
                        < div className="flex flex-col gap-4">
                                <div className="flex">
                                        <label className="block text-sm">Are you there?</label>
                                </div>
                                <div className="flex justify-center">
                                        <Button className="" size="lg" type="button" buttonStyle="primary" handleClick={onSubmit}>Stay Signed In</Button>
                                </div>
                        </div>
                </Modal>
        </>
}
